export enum CornerRadiusEnum {
  Default = "default",
  None = "none",
  Small = "small",
  Medium = "medium",
  Full = "full",
}

export type CornerRadiusType = keyof typeof CornerRadiusEnum;

export const CORNER_RADIUS_VALUES: Record<string, Record<string, string>> = {
  [CornerRadiusEnum.None]: {
    "--border-radius-xs": "1px",
    "--border-radius-sm": "1px",
    "--border-radius-md": "1px",
    "--border-radius-lg": "1px",
  },
  [CornerRadiusEnum.Small]: {
    "--border-radius-xs": "6px",
    "--border-radius-sm": "6px",
    "--border-radius-md": "9px",
    "--border-radius-lg": "12px",
  },
  [CornerRadiusEnum.Medium]: {
    "--border-radius-xs": "6px",
    "--border-radius-sm": "9px",
    "--border-radius-md": "18px",
    "--border-radius-lg": "27px",
  },
  [CornerRadiusEnum.Full]: {
    "--border-radius-xs": "20px",
    "--border-radius-sm": "30px",
    "--border-radius-md": "36px",
    "--border-radius-lg": "42px",
  },
};

/** The custom properties every radius preset sets. */
export const CORNER_RADIUS_TOKENS = Object.keys(
  CORNER_RADIUS_VALUES[CornerRadiusEnum.None]
);

export function getCornerRadiusValues(
  cornerRadius?: CornerRadiusType | string
): Record<string, string> | undefined {
  if (!cornerRadius || cornerRadius === CornerRadiusEnum.Default) {
    return undefined;
  }

  return CORNER_RADIUS_VALUES[cornerRadius];
}
